/**
 * Enum for Payment type values.
 * @readonlyP
 * @enum {number}
 */
export enum EPaymentType {
  CREDIT_CARD = 1,
  PHONE_CREDITS = 2,
  MICROCREDITS = 3,
  INVOICE = 4
}

export enum EPaymentForm {
  CREDIT_CARD = 'CREDIT_CARD',
  PHONE_CREDITS = 'PHONECREDIT',
  INVOICE = 'INVOICE',
  MICROCREDITS = 'MICROCREDIT'
}

export enum EPaymentName {
  PHONE_CREDIT = 'PHONE_CREDITS_USERS',
  INVOICE = 'INVOICE_USERS',
  CORP_INVOICE = 'CORP_INVOICE_USERS',
  MICROCREDITS = 'MICROCREDITS_USERS'
}
